import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { LABEL_PLACEMENT } from 'baseui/checkbox'
import SDCheckbox from '@/shared/components/SDComponentsNewDesign/SDCheckbox/SDCheckbox'

const SecondName = ({ children, currentValue, onClickHandler, disabled, hidden }) => {
  const { t } = useTranslation()

  if (hidden) {
    return null
  }

  return (
    <>
      <SDCheckbox
        checked={currentValue}
        onChange={onClickHandler}
        labelPlacement={LABEL_PLACEMENT.right}
        disabled={disabled}
        label={t('subscriptionForm:customer_module.secondName.label')}
      />
      {currentValue && <>{children}</>}
    </>
  )
}

SecondName.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onClickHandler: PropTypes.func,
  currentValue: PropTypes.bool,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
}

export default SecondName
